import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOptimalCluster = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 140 129",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M78.3001 116.735L88.5859 110.796L98.8716 104.858L119.443 92.9807L119.425 45.4803L78.2976 21.7147L37.1546 45.4686L37.1394 92.9881L78.3001 116.735Z",
			fill: "#C6D7F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.7318 107.391L73.0175 101.452L83.3032 95.5139L103.875 83.637L103.857 36.1365L62.7292 12.3709L21.5863 36.1248L21.571 83.6443L62.7318 107.391Z",
			stroke: "#082939",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M79.1418 49.3729C79.7443 50.0086 79.742 51.0367 79.1366 51.6694L58.9352 72.7794C58.3318 73.4099 57.3566 73.4099 56.7533 72.7794L47.5708 63.1839C46.9654 62.5513 46.9631 61.5231 47.5656 60.8875C48.1681 60.2518 49.1473 60.2493 49.7527 60.8819L57.8442 69.3374L76.9547 49.3674C77.5601 48.7348 78.5393 48.7372 79.1418 49.3729Z",
			fill: "#082939"
		})
	]
});
export default SvgOptimalCluster;
